import {
  barcodeFeeController,
  materialController,
  pfinvoice,
  srmSupInfoApi,
  rasUrl,
  srmSupInfo,
  dsmpSupDistribution,
  helpCenter,
  loginController,
  orderController,
  publicController,
  ecpEContractController,
  pfcBillInfoController,
  srmSupQualification,
  pOrderAdjustController,
  poscController,
  srmSupPriceController,
  pfcCombinedInvoice,
  srmSupProductQualification,
  supplierChargeReceipts,
  supplierReturn,
  supplierFine,
  supplierCargo,
  feedback,
  preDeliverController,
  supplierContractController,
  certController,
  paperInvoiceController,
  creatProdController,
  supSrvChargeController,
  supplierPoolController,
  supplierMarketingfeeController,
  supplierQualityController,
  supplierSupQualificationNewController,
  supContractController,
  supInvoiceController,
  supFrameController,
  ecpFrameContractController,
  postPaidController,
  bmsLogisticCloudApi,
  placeOrderController,
  passportController,
  supplierConfirmLetterController,
  qualificationTaskController
} from './controller'
import { getCookie } from '@/utils/cookie'

const initParam = (data) => Object.assign({}, data, { ticket: getCookie('mc_loguser_tickets') })

export default {
  // 登录相关
  supInfoByPassportList: () => loginController.post('supInfoByPassportList', initParam()),
  frameInfoByPassportList: () => loginController.post('frameInfoByPassportList', initParam()),
  login: (data) => loginController.post('login', initParam(data)),
  getUserInfo: (data) => loginController.post('getUserInfo'),

  // 物流云相关
  getIsConsignSale: (data) => bmsLogisticCloudApi.post('getIsConsignSale', data),
  createLogisticCloudAccount: (data) => bmsLogisticCloudApi.post('createLogisticCloudAccount', data),

  barcodeFeeDetails: (data) => barcodeFeeController.post('details', data),
  barcodeFeeAppeal: (data) => barcodeFeeController.post('appeal', data),
  barcodeFeeAdjustCount: (data) => barcodeFeeController.post('adjustCount', data),

  // 物资相关
  // getSupplierLevel: () => materialController.get('getSupplierLevel'), // (供应商支持)判断是否生态一级供应商 //1-自营,31-生态一级，32生态二级
  // materialSummaryList: (data) => materialController.post('summaryList', data), // 分页获取包装物对账列表
  // materialItemList: (data) => materialController.post('itemList', data), // 分页获取包装物对账列表
  // materialReturnAttachmentList: (data) => materialController.post('returnAttachmentList', data), // 获取包装物对账凭证
  // materialConfirm: (data) => materialController.post('confirm', data), // (物资支持)分页获取包装物明细列表
  // materialConfirmLog: (data) => materialController.post('confirmLog', data), // (物资支持)分页获取包装物明细列表
  // materialReturnList: (data) => materialController.post('returnList', data), // (物资支持)分页获取包装物明细列表
  // materialCompAttachmentList: (data) => materialController.post('compAttachmentList', data), // 退供确认列表查询

  selectInvoiceWithPage: (data) => pfinvoice.post('selectInvoiceWithPage', data), // 退供确认列表查询
  generateInvoiceNew: (data) => pfinvoice.post('generateInvoice', data), // 退供确认列表查询

  // oldSubmitInvoice: (data) => pfinvoice.post('oldSubmitInvoice', data), // 退供确认列表查询
  oldSubmitInvoice: (data) => pfinvoice.post('oldSubmitInvoice', data), // 退供确认列表查询
  // oldInvalidInvoice: (data) => pfinvoice.post('oldInvalidInvoice', data), // 退供确认列表查询
  oldInvalidInvoice: (data) => pfinvoice.post('cancelInvoice', data), // 退供确认列表查询

  // 订单相关
  printSupOrder: (data) => orderController.post('printSupOrder', {}),
  listSupOrderWithPage: (data) => orderController.post('listSupOrderWithPage', data),
  confirmHavePurchaseOrder: (data) => orderController.post('confirmHavePurchaseOrder', data),
  confirmNoPurchaseOrder: (data) => orderController.post('confirmNoPurchaseOrder', data),
  mapListInstockWithPage: (data) => orderController.post('mapListInstockWithPage', data),
  mapListReturnWithPage: (data) => orderController.post('mapListReturnWithPage', data),
  isFristNotice: (data) => orderController.post('isFristNotice', data),
  noticeRead: (data) => orderController.post('noticeRead', data),
  uploadWarehouseOrder: (data) => orderController.post('uploadWarehouseOrder', data), // 上传入库验收单
  listWarehouseOrderByStatus: (data) => orderController.post('listWarehouseOrderByStatus', data), // 根据状态查询入库验收单
  // 预约送货相关
  listNobookingInfo: (data) => preDeliverController.post('listNobookingInfo', data),
  preOccupy: (data) => preDeliverController.post('preOccupy', data),
  getWarehouseConfig: (data) => preDeliverController.post('getWarehouseConfig', data),
  createReserve: (data) => {
    return preDeliverController.post('create', data)
  },
  cancelReserve: (data) => preDeliverController.post('cancel', data),
  listbookingInfo: (data) => preDeliverController.post('listbookingInfo', data),
  // 电子印章
  mapListSignImageWithPage: (data) => ecpEContractController.post('mapListSignImageWithPage', data),
  createSignImage: (data) => ecpEContractController.post('createSignImage', data),
  delSignImage: (data) => ecpEContractController.post('delSignImage', data),
  saveSignImage: (data) => ecpEContractController.post('saveSignImage', data),
  uploadSignImage: (data) => ecpEContractController.post('uploadSignImage', data),
  getCompanyAuthFile: (data) => ecpEContractController.post('getCompanyAuthFile', data),
  cancelCompanyAuthFile: (data) => ecpEContractController.post('cancelCompanyAuthFile', data),
  getCompanyAuthFileUrl: (data) => ecpEContractController.post('getCompanyAuthFileUrl', data),
  getVerificationCode: (data) => ecpEContractController.post('getVerificationCode', data),
  checkCompanyAuthFile: (data) => ecpEContractController.post('checkCompanyAuthFile', data),
  // ========= 账单管理 =========
  // 账单信息列表查询
  mapListSupplierBillDataWithPage: (data) => pfcBillInfoController.post('mapListSupplierBillDataWithPage', data),
  // 供应商账单行信息查询
  mapListSupplierBillItemDataWithPage: (data) => pfcBillInfoController.post('mapListSupplierBillItemDataWithPage', data),
  // 确认金额不对
  confirmErrorSupplierBill: (data) => pfcBillInfoController.post('confirmErrorSupplierBill', data),
  // 确认账单
  confirmSupplierBill: (data) => pfcBillInfoController.post('confirmSupplierBill', data),
  // 获取账单类型列表
  listBillTypeData: (data) => pfcBillInfoController.post('listBillTypeData', data),
  // 批量确认
  confirmSupplierBillPatch: (data) => pfcBillInfoController.post('confirmSupplierBillPatch', data),

  // ====== 账单管理 end ======
  // 价格调整单
  listPriceAdjustByCondWithPage: (data) => pOrderAdjustController.post('listPriceAdjustByCondWithPage', data),
  // 供应商确认价格调整单
  confirmPriceAdjust: (data) => pOrderAdjustController.post('confirmPriceAdjust', data),
  // 价格调整单配置
  getPriceAdjustRule: (data) => pOrderAdjustController.post('getPriceAdjustRule', data),
  // 入库数量调整单
  mapListInstockOrder: (data) => pOrderAdjustController.post('mapListInstockOrder', data),
  // 退货调整单
  mapListReturnOrder: (data) => pOrderAdjustController.post('mapListReturnOrder', data),
  // 合同内的费用调整单
  mapListAdjustInfo: (data) => supplierChargeReceipts.post('mapListAdjustInfo', data),
  // 退货单
  // mapListReturnInfo: data => supplierReturn.post('mapListReturnInfo', data),
  listMiddleReturnInfo: (data) => supplierReturn.post('listMiddleReturnInfo', data),
  returnConfirmBySupplier: (data) => supplierReturn.post('returnConfirmBySupplier', data),
  // 罚款单
  mapListFineInfo: (data) => supplierFine.post('mapListFineInfo', data),
  // 合同内的费用单
  mapListInfo: (data) => supplierChargeReceipts.post('mapListInfo', data),
  queryWriteoffInChargeReceipts: (data) => supplierChargeReceipts.post('queryWriteoff', data),
  queryCollectFeeDetail: (data) => supplierChargeReceipts.post('queryCollectFeeDetail', data),
  queryCollectFeeConfig: (data) => supplierChargeReceipts.post('queryCollectFeeConfig', data),
  // 费用单据申请
  applyTicket: (data) => supplierChargeReceipts.post('applyTicket', data),
  // 费用单费用类型
  chargeType: (data) => supplierChargeReceipts.post('chargeType', data),
  paymentType: (data) => supplierChargeReceipts.post('paymentType', data),
  debitStatus: (data) => supplierChargeReceipts.post('debitStatus', data),
  invoiceStatus: (data) => supplierChargeReceipts.post('invoiceStatus', data),

  // =========== 宽进严出按周汇总收费 ===========
  queryChargeReceiptsSumPage: (data) => supSrvChargeController.post('queryChargeReceiptsSumPage', data), // 查询结算服务单列表

  // =========竞对毛补相关接口===========
  // getCompensateList: data => compensateController.post('mapList', data), // 获取补偿单列表
  // getCompensateStatus: () => compensateController.post('getStatusList'), // 获取罚单状态下拉框列表
  // getChargeTypeList: () => compensateController.post('getChargeList'), // 获取支付方式下拉框列表
  // getCompensateDetailList: data => compensateController.post('getDetailInfoPage', data), // 根据单据编号获取详细数据
  // confirmCompensateOrder: data => compensateController.post('confirm', data), // 确认竞对毛补单
  // rejectCompensateOrder: data => compensateController.post('reject', data), // 申诉竞对毛补单
  // 余额查询
  listSupBalance: (data) => poscController.post('listSupBalance', data),
  // 商品报价
  listSupGoods: (data) => srmSupPriceController.post('listSupGoods', data),
  confirmNormalPrice: (data) => srmSupPriceController.post('confirmNormalPrice', data),
  mapListCurrentPriceWithPage: (data) => srmSupPriceController.post('mapListCurrentPriceWithPage', data),
  mapListSpInfo: (data) => srmSupPriceController.post('mapListSpInfo', data),
  mapListHistoryPrice: (data) => srmSupPriceController.post('mapListHistoryPrice', data),
  // ====== 合并开票 ======
  // 获取账单列表接口
  mapListInvoicesDataWithPage: (data) => pfcCombinedInvoice.post('mapListInvoicesDataWithPage', data),
  mapListInvoiceDataWithPage: (data) => pfcCombinedInvoice.post('mapListInvoiceDataWithPage', data),
  mapListMergeInvoiceItemWithPage: (data) => pfcCombinedInvoice.post('mapListMergeInvoiceItemWithPage', data),
  mapListMergeInvoiceTaxItemWithPage: (data) => pfcCombinedInvoice.post('mapListMergeInvoiceTaxItemWithPage', data),
  mapListPaymentStatusWithPage: (data) => pfcCombinedInvoice.post('mapListPaymentStatusWithPage', data),
  removeInvoiceItem: (data) => pfcCombinedInvoice.post('removeInvoiceItem', data),
  listSupplierServiceUnitData: (data) => pfcCombinedInvoice.post('listSupplierServiceUnitData', data),
  listInvoiceQuotaData: (data) => pfcCombinedInvoice.post('listInvoiceQuotaData', data),
  listInvoiceTypeData: (data) => pfcCombinedInvoice.post('listInvoiceTypeData', data),
  listTaxData: (data) => pfcCombinedInvoice.post('listTaxData', data),
  listInvoiceStatusData: (data) => pfcCombinedInvoice.post('listInvoiceStatusData', data),
  updateInvoice: (data) => pfcCombinedInvoice.post('updateInvoice', data),
  submitInvoice: (data) => pfcCombinedInvoice.post('submitInvoice', data),
  cancelInvoice: (data) => pfcCombinedInvoice.post('cancelInvoice', data),
  mapListPFOperateHistory: (data) => pfcCombinedInvoice.post('mapListPFOperateHistory', data),
  generateInvoice: (data) => pfcCombinedInvoice.post('generateInvoice', data),
  invoiceUrge: (data) => pfcCombinedInvoice.post('invoiceUrge', data),
  getInvoiceType: () => pfcCombinedInvoice.post('getInvoiceType'),
  recognizeEticket: (data) => pfcCombinedInvoice.post('recognizeEticket', data, { timeout: 60000 }),
  // 红字信息表
  getRedInvoiceFormInfo: (data) => pfcCombinedInvoice.post('getRedInvoiceFormInfo', data),
  applyRedInvoiceFormInfo: (data) => pfcCombinedInvoice.post('applyRedInvoiceFormInfo', data),

  // 帮助中心
  mapListHelpInfo: (data) => {
    return helpCenter.post('mapListHelpInfo', data)
  },
  submit: (data) => {
    return feedback.post('submit', data)
  },
  feedbackList: (data) => feedback.post('listFeedback', data),
  // 第三方协同开票 获取地址
  getAssignUrl: (data) => rasUrl.post('getAssignUrl', data),

  // 直送订单
  mapListDistributionOrderNew: (data) => dsmpSupDistribution.post('mapListDistributionOrderNew', data),
  mapListDistributionOrderVerifying: (data) => dsmpSupDistribution.post('mapListDistributionOrderVerifying', data),
  getDsmpOrderCompanyList: (data) => dsmpSupDistribution.post('getDsmpOrderCompanyList', data),
  checkOmcVerifyCodeBatch: (data) => dsmpSupDistribution.post('checkOmcVerifyCodeBatch', data),
  sendCompanySmsBatch: (data) => dsmpSupDistribution.post('sendCompanySmsBatch', data),
  cancelVerifyCodeBatch: (data) => dsmpSupDistribution.post('cancelVerifyCodeBatch', data),
  changeOmcOrderNew: (data) => dsmpSupDistribution.post('changeOmcOrderNew', data),

  // 公用方法
  // ========= 资质管理 =========
  // 获取营业执照等 基础资质
  getSupQualificationInfo: (data) => srmSupQualification.post('getSupQualificationInfo', data),
  // 获取资格证列表等 拓展资质
  getSupQualificationExtInfo: (data) => srmSupQualification.post('getSupQualificationExtInfo', data),
  // 修改基础资质
  modifySupplierQualificationInfo: (data) => srmSupQualification.post('modifySupplierQualificationInfo', data),
  // 修改拓展资质
  modifySupplierQualificationExtInfo: (data) => srmSupQualification.post('modifySupplierQualificationExtInfo', data),
  // 查看基础资质修改日志
  getSupQualificationChangeHistoryInfo: (data) => srmSupQualification.post('getSupQualificationChangeHistoryInfo', data),
  // 查看拓展证件修改日志
  getSupQualificationExtChangeHistoryInfo: (data) => srmSupQualification.post('getSupQualificationExtChangeHistoryInfo', data),
  // 获取供应商商品资质列表接口
  getSupplierProductList: (data) => srmSupProductQualification.post('getSupplierProductList', data),
  // 查看产品库资质审核日志
  getSupplierDocumentChangeList: (data) => srmSupProductQualification.post('getSupplierDocumentChangeList', data),
  // 获取获取供应商产品库修改前资质
  getSupplierProductQualification: (data) => srmSupProductQualification.post('getSupplierProductQualification', data),
  // 修改产品库资质接口
  modifySupplierProductQualification: (data) => srmSupProductQualification.post('modifySupplierProductQualification', data),
  // 查看产品库资质（待审核、审核通过、审核不通过）
  getSupplierDocumentChangeFlow: (data) => srmSupProductQualification.post('getSupplierDocumentChangeFlow', data),
  // 检查供应商状态
  checkSupplierStatus: () => srmSupQualification.post('checkSupplierStatus'),
  // ========= 公用方法 =========
  listWithWarehouseByCity: (data) => publicController.post('listWithWarehouseByCity', {}),
  getEmbedUrls: (data) => publicController.post('getEmbedUrls'),
  getBizLog: (data) => publicController.post('bizlog/query'), // 查询操作日志

  // 供应商城市列表
  listSupplierCity: (data) => publicController.post('listSupplierCity', data),
  // 业务城市列表
  listBizCity: (data) => publicController.post('listBizCity'),
  // 获取一级分类
  listSupplierClass: (data) => publicController.post('listSupplierClass'),
  // 根基一级分类获取二级分类
  listClass2ByClass1: (data) => publicController.post('listClass2', data),
  // 获取客服电话
  getPhone: (data) => publicController.post('getPhone'),
  // 获取采购电话
  supplierWaiter: (data) => srmSupInfo.post('supplierWaiter'),
  // ========== 联合拜访 ===========
  // 查询拜访任务列表
  // listSupplierVisitWithPage: data => supplierVisit.post('listSupplierVisitWithPage', data),
  // 查询商户类型
  // listMerchantType: data => supplierVisit.post('listMerchantType'),
  // 分配城市列表
  // listShareCity: data => supplierVisit.post('listShareCity'),
  // 查看分配状态列表
  // listShareStatus: data => supplierVisit.post('listShareStatus'),
  // 查看分配销售列表
  // listSupplierShareSale: data => supplierVisit.post('listSupplierShareSale', data),
  // 分配拜访任务
  // shareSupplierVisit: data => supplierVisit.post('shareSupplierMerchant', data),
  // 查看商户列表
  // listSupplierMerchant: data => supplierVisit.post('listSupplierMerchant', data),
  // 统计商户个数
  // countSupplierMerchant: data => supplierVisit.post('countSupplierMerchant', data),
  // 查询销售列表
  // listPassportAccount: data => srmSupInfoApi.post('listPassportAccount', data),
  // 重新分配商户
  // reShareSupplierMerchant: data => supplierVisit.post('reShareSupplierMerchant', data),
  // ============== 联合拜访二期 ==============
  // getVisitEffectData: data => supplierVisitController.post('countSupplierVisitMerchant', data),
  // getSaleCompletionList: data => supplierVisitController.post('querySaleCompletionInfo', data),
  // getSaleDetailList: data => supplierVisitController.post('querySaleDetailInfo', data),
  // ============== 供应商税率 ==============
  // 获取货主ID以及加密sign
  getCargoSign: (data) => supplierCargo.post('getCargoSign', data),

  // ==============纸质发票 ===========

  getInvoiceSwitch: (data) => paperInvoiceController.post('switch', data), // 配置开关
  getRecognize: (data) => paperInvoiceController.post('recognize', data, { timeout: 60000 }), // 发票识别
  getDeliveryList: (data) => paperInvoiceController.post('getDeliveryList', data), // 物流信息列表
  submitDelivery: (data) => paperInvoiceController.post('submitDelivery', data), // 提交物流信息
  asmInvoiceList: (data) => paperInvoiceController.post('asmInvoiceList', data), // 融合平台列表查询
  submitAsmDelivery: (data) => paperInvoiceController.post('submitAsmDeliveryInfo', data), // 融合平台快递单保存(即发票提交)
  submitAsmImage: (data) => paperInvoiceController.post('submitImage', data), // 融合平台保存图片链接

  // ==========宽进严出(服务费)===========
  getSupSrvChargeList: (data) => supSrvChargeController.post('mapList', data), // 列表
  getChargeReceiptsDetail: (data) => supSrvChargeController.post('getChargeReceiptsDetail', data), // 列表服务费
  queryListChargeReceiptsByMonth: (data) => supSrvChargeController.post('queryListChargeReceiptsByMonth', data), // 服务单明细

  // ==========对账单===========
  listInvoiceSyncInfo: (data) => pfcCombinedInvoice.post('listInvoiceSyncInfo', data), // 列表
  // =============自主建品================
  getProductList: (data) => creatProdController.post('getProductList', data),
  checkProduct: (data) => creatProdController.post('checkProduct', data),
  getProdDetail: (data) => creatProdController.post('getDetail', data),
  getNewProdDetail: (data) => creatProdController.post('getNewDetail', data),
  getClass1ListBySupplierId: (data) => creatProdController.post('getSupplierPurchaseClass1BySupplierId', data),
  getPopClass1List: (data) => publicController.post('listClass1', data),
  getClass1List: (data) => creatProdController.post('getClass1List', data),
  getClass2List: (data) => creatProdController.post('getClass2List', data),
  getClass3List: (data) => creatProdController.post('getClass3List', data),
  submitProduct: (data) => creatProdController.post('submit', data),
  queryCommonName: (data) => creatProdController.post('queryCommonName', data),
  getOriginDict: (data) => creatProdController.post('getOriginDict', data),
  getTemplate: (data) => creatProdController.post('getTemplate', data),
  getAttrNameList: (data) => creatProdController.post('getAttrNameList', data),
  getMeasureDict: (data) => creatProdController.post('getMeasureDict', data),
  checkIcode: (data) => creatProdController.post('checkIcode', data), // 国际码校验
  queryAuditList: (data) => creatProdController.post('queryNewAuditList', data), // 审核列表
  getAuditDetail: (data) => creatProdController.post('getAuditDetail', data), // 审核详情
  getNewAuditDetail: (data) => creatProdController.post('getNewAuditDetail', data), // 审核详情
  delGoods: (data) => creatProdController.post('delete', data), // 删除建品信息
  newDelGoods: (data) => creatProdController.post('newDelete', data), // 删除建品信息
  auditEnumList: (data) => creatProdController.post('auditEnumList', data), // 建品状态列表
  storeGoods: (data) => creatProdController.post('storage', data), // 建品暂存
  queryBiName: (data) => creatProdController.post('queryBiName', data), // 查找通用名
  getArchiveTask: (data) => creatProdController.post('getArchiveTask', data), // sku审核详情
  getNewAuditLog: (data) => creatProdController.post('getNewAuditLog', data), // 获取审核中商品日志
  getPurchaseClass1List: (data) => creatProdController.post('getPurchaseClass1List', data), // 采销分类
  querySkuList: (data) => creatProdController.post('querySkuList', data), // 查询sku
  queryProductCreateSwitch: (data) => creatProdController.post('queryProductCreateSwitch', data), // 查询sku

  // =========自主建品-商品资质============
  getSupplierContract: (data) => supplierContractController.post('listNoDupliacateByFSupplierBasic', data), // 查询供应商合同分类
  getCertList: (data) => certController.post('queryList', data),
  createCert: (data) => certController.post('add', data),
  modifyCert: (data) => certController.post('modify', data),
  delCert: (data) => certController.post('delete', data),
  getCertAuditLogList: (data) => certController.post('getLogList', data),
  getSupplierDocumentChangePageList: (data) => certController.post('supplierDocumentChangePageList', data),
  getCertDetail: (data) => certController.post('getDetail', data),
  getNewCertDetail: (data) => certController.post('getNewDetail', data),
  validateCertClass: (data) => certController.post('validateClass', data),
  queryBindSkuList: (data) => certController.post('queryBindSkuList', data),
  appealSupSrvCharge: (data) => supSrvChargeController.post('appealAdjustOrder', data), // 申诉接口
  // =========合同费用开票============
  selectContractBills: (data) => supplierChargeReceipts.post('selectContractBills', data), // 列表
  selectTicketBills: (data) => supplierChargeReceipts.post('selectTicketBills', data), // 可开票数据
  invoiceVerify: (data) => supplierChargeReceipts.post('invoiceVerify', data), // 校验开票信息
  selectCityInfo: (data) => supplierChargeReceipts.post('selectCityInfo', data), // 省市区联动列表
  applyInvoice: (data) => supplierChargeReceipts.post('applyInvoice', data), // 开票
  invoiceDetail: (data) => supplierChargeReceipts.post('invoiceDetail', data), // 开票详情

  queryInvoicePlan: (data) => supplierChargeReceipts.post('/invoice/queryPlan', data), // 开票申请集合
  queryInvoicePlanItem: (data) => supplierChargeReceipts.post('/invoice/queryPlanItem', data), // 开票申请明细集合
  queryInvoiceInfo: (data) => supplierChargeReceipts.post('/invoice/queryInfo', data), // 发票明细集合
  applyInvalidInvoicePlan: (data) => supplierChargeReceipts.post('/invoice/applyInvalidPlan', data), // 发票申请作废
  lastInvoice: (data) => supplierChargeReceipts.post('/invoice/getLastInvoice', data),
  modifyInvoiceTitle: (data) => supplierChargeReceipts.post('/invoice/modifyInvoiceTitle', data),

  // ==========供应商储备池==============
  getClass1InSupplierPool: (data) => publicController.post('getAllListClass1', data),
  getClass2InSupplierPool: (data) => publicController.post('getListClass2ByClass1', data),
  submitSupplierInfo: (data) => supplierPoolController.post('submitSupplierInfo', data),

  // =========== 供应商营销费 ===========
  queryMarketingfeeDetail: (data) => supplierMarketingfeeController.post('queryMarketingfeeDetail', data),
  queryActivity: (data) => supplierMarketingfeeController.post('queryActivity', data),
  queryOrderList: (data) => supplierMarketingfeeController.post('queryOrderList', data),
  queryStatistics: (data) => supplierMarketingfeeController.post('statistics', data),
  selectTask: (data) => supplierMarketingfeeController.post('selectTask', data),
  selectSupplierCountInfo: (data) => supplierMarketingfeeController.post('selectSupplierCountInfo', data),
  selectSalesOrder: (data) => supplierMarketingfeeController.post('selectSalesOrder', data),
  // =========== 商品信息：商品标准和商品属性 ===========
  queryInspectStandardInfo: (data) => supplierQualityController.post('inspectStandardInfo', data),
  queryAttrInfo: (data) => supplierQualityController.post('attrInfo', data),
  // =========== 供应商资质 =============
  getSupplierQualificationManageInfo: (data) => supplierSupQualificationNewController.post('getSupplierQualificationManageInfo', data),
  supplierQualificationManageEdit: (data) => supplierSupQualificationNewController.post('supplierQualificationManageEdit', data),
  listSupplierType: (data) => publicController.post('listSupplierType', data),
  listSupplierQualificationExtType: (data) => publicController.post('listSupplierQualificationExtType', data),
  supplierQuaClassMapByCondition: (data) => supplierSupQualificationNewController.post('supplierQuaClassMapByCondition', data),
  listClassTree: (data) => publicController.post('listClassTree', data),
  getTaxClassRelationConfig: (data) => supplierSupQualificationNewController.post('getTaxClassRelationConfig', data),
  // =========== 合同签署 =========
  getPageList: (data) => supContractController.post('pageList', data),
  queryImage: (data) => supContractController.post('queryImage', data),
  sendSms: (data) => supContractController.post('sendSms', data),
  refuse: (data) => supContractController.post('refuse', data),
  sign: (data) => supContractController.post('sign', data),
  querySignImagePoi: (data) => supContractController.post('querySignImagePoi', data),
  getContractPageList: (data) => supContractController.post('pageList', data),
  getContractDkhPageList: (data) => supContractController.post('dkhPageList', data),
  singeContractGetPhone: (data) => supContractController.post('getPhone', data),

  // =========== 合同签署 =========
  // ========我的资质======
  getMangeInvoiceWithPage: (data) => supInvoiceController.post('getMangeInvoiceWithPage', data),
  getInvoiceItemWithPage: (data) => supInvoiceController.post('getInvoiceItemWithPage', data),
  getMergeInvoiceItemWithPage: (data) => supInvoiceController.post('getMergeInvoiceItemWithPage', data),
  invalidInvoice: (data) => supInvoiceController.post('invalidInvoice', data),
  cancelSupInvoice: (data) => supInvoiceController.post('cancelInvoice', data),
  // ===========我的资质

  // ===========框架协议======
  framePageList: (data) => supFrameController.post('pageList', data),
  frameQuerySignImagePoi: (data) => supFrameController.post('querySignImagePoi', data),
  frameQueryImage: (data) => supFrameController.post('queryImage', data),
  frameTotalImage: (data) => supFrameController.post('totalImage', data),
  frameSendSms: (data) => supFrameController.post('sendSms', data),
  frameRefuse: (data) => supFrameController.post('refuse', data),
  frameSign: (data) => supFrameController.post('sign', data),
  framePreview: (data) => supFrameController.post('preview', data),
  frameDelSignImage: (data) => supFrameController.post('delSignImage', data),

  // ===========框架协议======

  frameMapListSignImageWithPage: (data) => ecpFrameContractController.post('mapListSignImageWithPage', data),
  frameCreateSignImage: (data) => ecpFrameContractController.post('createSignImage', data),
  frameDelSignImage: (data) => ecpFrameContractController.post('delSignImage', data),
  frameSaveSignImage: (data) => ecpFrameContractController.post('saveSignImage', data),
  frameUploadSignImage: (data) => ecpFrameContractController.post('uploadSignImage', data),

  frameGetCompanyAuthFile: (data) => ecpFrameContractController.post('getCompanyAuthFile', data),
  frameCancelCompanyAuthFile: (data) => ecpFrameContractController.post('cancelCompanyAuthFile', data),
  frameGetCompanyAuthFileUrl: (data) => ecpFrameContractController.post('getCompanyAuthFileUrl', data),

  // ===========后付费管理======
  getList: (data) => postPaidController.post('query', data),
  queryWriteOff: (data) => postPaidController.post('writeoff/query', data),
  confirmWriteOff: (data) => postPaidController.post('writeoff/confirm', data),
  // ===========后付费管理======

  // ===========自主下单======
  getWarehouseList: (data) => publicController.post('listWithWarehouseByCity', data),
  getClass1: (data) => publicController.post('listSupplierClass', data),
  getClass2: (data) => publicController.post('listClass2', data),
  getArrivalTimeConfig: (data) => placeOrderController.post('getArrivalTimeAcmConfig', data),
  getSupplierPorderList: (data) => placeOrderController.post('search', data),
  placeOrder: (data) => placeOrderController.post('create', data),
  getGrayConfig: (data) => placeOrderController.post('grayscale', data),
  checkRisk: (data) => placeOrderController.post('checkRisk', data),
  // ===========自主下单======

  // ===========供应商管理=========
  queryPassportPageList: () => passportController.post('queryPassportPageList'),
  updateSupplierAccount: (data) => passportController.post('update', data),
  checkPhone: (data) => passportController.get(`checkphone?phone=${data}`),
  getSupplierUpdateAccountLogList: (data) => passportController.post('logList', data),
  // ===========供应商管理=========

  // 供应商对账单
  queryConfirmLetterPage: (data) => supplierConfirmLetterController.post('queryPage', data),
  getConfirmLetterById: (data) => supplierConfirmLetterController.post('getById', data),
  confirmConfirmLetter: (data) => supplierConfirmLetterController.post('confirm', data),
  querySupplierBalancePage: (data) => poscController.post('querySupplierBalanceInfo', data),
  // 供应商对账单
  fetchPurchaseList: (data) => materialController.post('purchaseCompensation/list', data),
  applyPurchase: (data) => materialController.post('purchaseCompensation/applyFor', data),

  // 资质任务
  queryTaskPage: (data) => qualificationTaskController.post('queryTaskPage', data),
  submitTaskPics: (data) => qualificationTaskController.post('submitTaskPics', data)
}



// WEBPACK FOOTER //
// ./src/api/index.js